// Populate dropdowns from card data attributes
(function() {
  var locations = new Set();
  var departments = new Set();
  document.querySelectorAll('.careers-job-card').forEach(function(card) {
    if (card.dataset.location) locations.add(card.dataset.location);
    if (card.dataset.department) departments.add(card.dataset.department);
  });
  var locSelect = document.getElementById('careers-location');
  var deptSelect = document.getElementById('careers-department');
  locations.forEach(function(loc) {
    var opt = document.createElement('option');
    opt.value = loc; opt.textContent = loc;
    locSelect.appendChild(opt);
  });
  departments.forEach(function(dept) {
    var opt = document.createElement('option');
    opt.value = dept; opt.textContent = dept;
    deptSelect.appendChild(opt);
  });
})();

function updateCardBorders() {
  var allCards = document.querySelectorAll('.careers-job-card');
  var visibleCards = [];
  allCards.forEach(function(card) {
    card.style.borderRight = '';
    card.style.borderBottom = '';
    if (card.style.display !== 'none') visibleCards.push(card);
  });
  if (window.innerWidth >= 750) {
    visibleCards.slice(0, -1).forEach(function(card) { card.style.borderRight = '0'; });
  } else {
    visibleCards.slice(0, -1).forEach(function(card) { card.style.borderBottom = '0'; });
  }
}

function filterJobs() {
  var query = document.getElementById('careers-search').value.toLowerCase().trim();
  var location = document.getElementById('careers-location').value;
  var department = document.getElementById('careers-department').value;
  var cards = document.querySelectorAll('.careers-job-card');
  var visible = 0;

  cards.forEach(function(card) {
    var matchTitle = !query || card.dataset.title.includes(query);
    var matchLocation = !location || card.dataset.location === location;
    var matchDept = !department || card.dataset.department === department;
    var show = matchTitle && matchLocation && matchDept;
    card.style.display = show ? '' : 'none';
    if (show) visible++;
  });

  document.getElementById('careers-no-results').style.display = visible === 0 ? 'block' : 'none';
  var countEl = document.querySelector('.careers-count');
  if (countEl) countEl.style.display = visible === 0 ? 'none' : '';
  updateCardBorders();
}

document.getElementById('careers-search').addEventListener('input', filterJobs);
document.getElementById('careers-location').addEventListener('change', filterJobs);
document.getElementById('careers-department').addEventListener('change', filterJobs);
document.getElementById('careers-reset').addEventListener('click', function() {
  document.getElementById('careers-search').value = '';
  document.getElementById('careers-location').value = '';
  document.getElementById('careers-department').value = '';
  filterJobs();
});

function showListing() {
  document.getElementById('careers-listing-view').classList.remove('is-hidden');
  var detailView = document.getElementById('careers-detail-view');
  detailView.classList.remove('is-active');
  detailView.innerHTML = '';
  history.pushState('', document.title, window.location.pathname);
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function showJobFromHash() {
  var hash = window.location.hash;

  if (hash && hash.startsWith('#job-')) {
    var handle = hash.replace('#job-', '');
    var detailScript = document.getElementById('detail-' + handle);

    if (detailScript) {
      var detailView = document.getElementById('careers-detail-view');
      detailView.innerHTML = detailScript.textContent;
      detailView.classList.add('is-active');
      document.getElementById('careers-listing-view').classList.add('is-hidden');
      document.getElementById('careers-back-btn').addEventListener('click', showListing);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
  }
  showListing();
}

document.querySelectorAll('.careers-job-card').forEach(function(card) {
  card.addEventListener('click', function() {
    var handle = this.getAttribute('data-job');
    history.pushState(null, '', '#job-' + handle);
    showJobFromHash();
  });
});

window.addEventListener('popstate', showJobFromHash);
showJobFromHash();
updateCardBorders();
